var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardPlatinum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.94 155.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #010101;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clippath);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 240.94,
    height: 155.91,
    rx: 7.71,
    ry: 7.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 108.66,
    y1: 174.9,
    x2: 313.19,
    y2: -29.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6d71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8a8a8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#bcbcbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#e0e0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f6f6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#606264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#17191a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#a6a7a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cccdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e8e8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e6e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c8c8cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebfc2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 240.94,
    height: 155.91,
    rx: 7.71,
    ry: 7.71
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.02,55.3c6.65,9.54,7.76,16.02,7.76,16.02,0,0-5.22,4.13-16.73,6.77,11.45,2.03,16.81,5.83,16.81,5.83,0,0-.77,6.62-7.04,16.62,9.53-6.66,16.01-7.76,16.01-7.76,0,0,4.13,5.23,6.77,16.73,2.04-11.45,5.84-16.81,5.84-16.81,0,0,6.62.77,16.62,7.04-6.65-9.54-7.76-16.02-7.76-16.02,0,0,5.23-4.13,16.74-6.77-11.46-2.04-16.81-5.84-16.81-5.84,0,0,.77-6.62,7.04-16.61-9.54,6.65-16.01,7.76-16.01,7.76,0,0-4.13-5.22-6.77-16.73-2.04,11.45-5.84,16.81-5.84,16.81,0,0-6.62-.77-16.62-7.05ZM120.47,69.43c.17-12.72,4.24-19.7,4.24-19.7,1.89,1.99,8.87,7.97,19.74,11.83,10.87,3.86,23.18.86,23.18.86,0,0-7.14-10.45-17.8-14.86-10.66-4.39-19.85-4.62-22.59-4.41,0,0,1.65-7.92,10.03-17.48,0,0,9.82-.11,22.31,7.31-7.93-11.98-8.33-21.67-8.33-21.67C160.37,2.43,168.19.37,168.19.37c-.07,2.75.63,11.91,5.59,22.33,4.95,10.42,15.77,16.99,15.77,16.99,0,0,2.35-12.44-2.08-23.09-4.43-10.65-10.77-17.3-12.85-19.1,0,0,6.76-4.43,19.46-5.26,0,0,7.02,6.86,10.6,20.94,2.87-14.08,9.44-21.22,9.44-21.22,12.72.16,19.71,4.24,19.71,4.24-1.99,1.9-7.97,8.87-11.83,19.74-3.87,10.87-.86,23.17-.86,23.17,0,0,10.46-7.13,14.86-17.8,4.4-10.67,4.62-19.85,4.42-22.59,0,0,7.92,1.64,17.48,10.04,0,0,.11,9.82-7.31,22.3,11.99-7.92,21.68-8.32,21.68-8.32,8.88,9.11,10.93,16.93,10.93,16.93-2.74-.06-11.91.64-22.33,5.6-10.42,4.96-16.99,15.78-16.99,15.78,0,0,12.43,2.35,23.09-2.08,10.66-4.43,17.31-10.77,19.1-12.85,0,0,4.44,6.77,5.26,19.46,0,0-6.86,7.02-20.94,10.6,14.07,2.87,21.22,9.44,21.22,9.44-.17,12.71-4.25,19.7-4.25,19.7-1.89-1.99-8.87-7.96-19.74-11.83-10.86-3.86-23.17-.86-23.17-.86,0,0,7.13,10.45,17.8,14.86,10.66,4.4,19.85,4.63,22.59,4.42,0,0-1.64,7.91-10.04,17.48,0,0-9.82.11-22.3-7.31,7.93,11.98,8.33,21.67,8.33,21.67-9.12,8.88-16.93,10.94-16.93,10.94.06-2.75-.64-11.91-5.59-22.33-4.96-10.42-15.78-16.99-15.78-16.99,0,0-2.35,12.43,2.08,23.09,4.43,10.65,10.77,17.31,12.85,19.1,0,0-6.76,4.43-19.46,5.26,0,0-7.02-6.86-10.6-20.94-2.87,14.07-9.44,21.21-9.44,21.21-12.71-.17-19.7-4.24-19.7-4.24,1.99-1.89,7.97-8.87,11.83-19.74,3.87-10.87.86-23.17.86-23.17,0,0-10.45,7.13-14.86,17.79-4.4,10.67-4.63,19.86-4.41,22.6,0,0-7.92-1.65-17.48-10.04,0,0-.11-9.82,7.31-22.3-11.98,7.92-21.67,8.32-21.67,8.32-8.88-9.11-10.94-16.93-10.94-16.93,2.75.07,11.91-.63,22.33-5.59,10.42-4.95,17-15.78,17-15.78,0,0-12.44-2.35-23.09,2.08-10.65,4.43-17.31,10.77-19.09,12.85,0,0-4.44-6.77-5.26-19.46,0,0,6.86-7.02,20.94-10.6-14.07-2.87-21.21-9.45-21.21-9.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPlatinum);
export default __webpack_public_path__ + "static/media/credit_card_platinum.1ddb6b6c3d2777baa3330c78753bc372.svg";
export { ForwardRef as ReactComponent };